<div class="page-container">

  <header>
    <div class="crumb">
      <span data-icon="petition" class="icon-before">Petitions</span>
    </div>
    <div class="spacer"></div>
    @if (user?.staff) {
      <a mat-raised-button color="primary" routerLink="/campaigns/new">
        <mat-icon>add</mat-icon>
        New
      </a>
    }
  </header>

  <div class="grouped-petitions">
    @if (!groupedPetitions) {
      <div class="featured">
        <div class="topic">
          <div role="img"></div>
          <div class="star"><mat-icon>star</mat-icon></div>
          <h2><span class="placeholder"></span></h2>
          <a mat-button class="neutral corner" href="javascript:;">
            <span class="placeholder"></span>
          </a>
        </div>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
      </div>
      <div>
        <div class="topic">
          <div role="img"></div>
          <h2><span class="placeholder"></span></h2>
          <a role="button" class="neutral corner" href="javascript:;">
            <span class="placeholder"></span>
          </a>
        </div>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
      </div>
      <div>
        <div class="topic">
          <div role="img"></div>
          <h2><span class="placeholder"></span></h2>
          <a role="button" class="neutral corner" href="javascript:;">
            <span class="placeholder"></span>
          </a>
        </div>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
      </div>
      <div class="featured">
        <div class="topic">
          <div role="img"></div>
          <div class="star"><mat-icon>star</mat-icon></div>
          <h2><span class="placeholder"></span></h2>
          <a role="button" class="neutral corner" href="javascript:;">
            <span class="placeholder"></span>
          </a>
        </div>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
      </div>
    }
    @if (groupedPetitions) {
      @for (group of groupedPetitions; track group; let index = $index) {
        <div [class.featured]="isFeatured(group, index)">
          <div class="topic">
            <a [routerLink]="['/petitions', group.polls[0]?.slug]" class="petition-link">
              <div role="img" [responsiveBackgroundImage]="group.topic.backdrop_image"></div>
              @if (isFeatured(group, index)) {
                <div class="star">
                  <mat-icon>star</mat-icon>
                </div>
              }
              <h2>{{ group.topic.name }}</h2>
            </a>
            <a mat-button class="neutral sharp corner" [routerLink]="['topics', group.topic.slug]">
              <mat-icon>open_in_browser</mat-icon>
              See All
            </a>
          </div>
          @for (petition of group.polls; track petition) {
            <tyt-petition-card [petition]="petition"></tyt-petition-card>
          }
        </div>
      }
    }
  </div>

  <div class="crumb">
    <span data-icon="petition" class="icon-before">Other Campaigns</span>
    <a role="button" class="neutral sharp" [routerLink]="['all']">
      <mat-icon>open_in_browser</mat-icon>
      See All
    </a>
  </div>

  <div class="other-campaigns">
    @if (!petitions) {
      @for (v of undefined | repeat: 10; track v) {
        <tyt-petition-card [placeholder]="true"></tyt-petition-card>
      }
    }
    @if (petitions) {
      @for (petition of petitions; track petition) {
        <tyt-petition-card [petition]="petition"></tyt-petition-card>
      }
    }
  </div>

</div>
